import React, { useContext } from 'react'
import StoreContext from '~/context/StoreContext'

export function formatTitle(title) {
  return title
    .replace('Banana', '<span>Banana</span>')
    .replace('Cinnamon', '<span>Cinnamon</span><br/>')
    .replace('Sour Cherry', '<span>Sour Cherry</span>')
    .replace('Dark Chocolate', '<span>Dark Chocolate</span>')
    .replace('Lemon', '<span>Lemon</span>')
    .replace('Ginger', '<span>Ginger</span><br/>')
    .replace('Taster', '<span>Taster</span>')
    .replace('CBD', '<span>CBD</span>')
    .replace('Flow State', '<span>Flow State</span>')
    .replace('Nootropics', '<span>Nootropics</span>')
}

export function getBackgroundColor(handle) {
  if (handle.indexOf('lemon') > -1) {
    return 'transparent'
  } else if (handle.indexOf('banana') > -1) {
    return 'transparent'
  } else if (handle.indexOf('cherry') > -1) {
    return 'transparent'
  } else {
    return '#dcd0af'
  }
}

export function getButtonBackground(handle) {
  if (handle.indexOf('lemon') > -1) {
    return '#ffcb2c'
  } else if (handle.indexOf('banana') > -1) {
    return '#F09565'
  } else if (handle.indexOf('cherry') > -1) {
    return '#28C2CD'
  } else {
    return null
  }
}

export function getButtonColor(handle) {
  // return 'white'
  if (handle.indexOf('lemon') > -1) {
    return '#142F1F'
  } else {
    return 'white'
  }
}

export function getReviewCount(handle) {
  if (handle.indexOf('lemon') > -1) {
    return 87
  } else if (handle.indexOf('banana') > -1) {
    return 94
  } else if (handle.indexOf('cherry') > -1) {
    return 143
  } else {
    return 112
  }
}

export const GetPrice = price => {
  const {
    store: { checkout },
  } = useContext(StoreContext)
  return Intl.NumberFormat(undefined, {
    currency: checkout.currencyCode ? checkout.currencyCode : 'GBP',
    minimumFractionDigits: 2,
    style: 'currency',
  })
    .format(parseFloat(price ? price : 0))
    .replace('.00', '')
}

export function getIngredients(handle) {
  if (handle.indexOf('lemon') > -1) {
    return (
      <div>
        <p>
          Dried Apricots (Dried Apricot, Rice Flour), Gluten Free Rolled{' '}
          <strong>Oats</strong>, <strong>Almond</strong> Butter, Chicory Root
          Fibre, Cacao Butter, Maca Powder, L-Theanine, Freeze Dried Lemon
          Powder (0.5%), CBD Oil (CBD Extract, MCT Oil), Ginger (0.5%), Lemon
          Oil (0.5%).
        </p>
        <p>
          Allergen advice: For allergens, including cereals containing gluten
          see ingredients in <strong>bold</strong>. Made on a site which handles
          nuts.
        </p>
      </div>
    )
  } else if (handle.indexOf('banana') > -1) {
    return (
      <div>
        <p>
          Dried Banana (Dried Banana, Rice Flour) (23%), <strong>Almond</strong>{' '}
          Butter, Gluten Free Rolled <strong>Oats</strong>, Dried Apricots
          (Dried Apricot, Rice Flour), Chicory Root Fibre, Cacao Butter, Ground
          Cinnamon (1.6%), Maca Powder, L-Theanine, CBD Oil (CBD Extract, MCT
          Oil).
        </p>
        <p>
          Allergen advice: For allergens, including cereals containing gluten
          see ingredients in <strong>bold</strong>. Made on a site which handles
          nuts.
        </p>
      </div>
    )
  } else if (handle.indexOf('cherry') > -1) {
    return (
      <div>
        <p>
          Dried Apricots (Dried Apricot, Rice Flour), Dried Sour Cherries (Dried
          Sour Cherry, Apple Juice Concentrate, Sunflower Oil) (18%), Gluten
          Free Rolled <strong>Oats</strong>, <strong>Almond</strong> Butter, Raw
          Dark Chocolate (9%) (Raw Cacao Mass, Coconut Sugar, Cacao Butter),
          Cacao Butter, Chicory Root Fibre, Vanilla Extract, Maca Powder,
          L-Theanine, CBD Oil (CBD Extract, MCT Oil).
        </p>
        <p>
          Allergen advice: For allergens, including cereals containing gluten
          see ingredients in <strong>bold</strong>. Made on a site which handles
          nuts.
        </p>
      </div>
    )
  } else {
    return null
  }
}

export function getNutritionTable(handle) {
  if (handle.indexOf('lemon') > -1) {
    return (
      <div>
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>per 100g</th>
              <th>per 45g serving</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Energy</td>
              <td>1449.8kJ</td>
              <td>652.4kJ</td>
            </tr>
            <tr>
              <td>Energy</td>
              <td>345.1kcal</td>
              <td>155.3kcal</td>
            </tr>
            <tr>
              <td>Fat</td>
              <td>17.5g</td>
              <td>7.9g</td>
            </tr>
            <tr>
              <td>&nbsp; &nbsp; &nbsp;of which saturates</td>
              <td>4.7g</td>
              <td>2.1g</td>
            </tr>
            <tr>
              <td>Carbohydrates</td>
              <td>34.5g</td>
              <td>15.5g</td>
            </tr>
            <tr>
              <td>&nbsp; &nbsp; &nbsp;of which sugars</td>
              <td>17.2g</td>
              <td>7.8g</td>
            </tr>
            <tr>
              <td>Added Sugar</td>
              <td>0.0g</td>
              <td>0.0g</td>
            </tr>
            <tr>
              <td>Fibre</td>
              <td>7.9g</td>
              <td>3.5g</td>
            </tr>
            <tr>
              <td>Protein</td>
              <td>10.8g</td>
              <td>4.9g</td>
            </tr>
            <tr>
              <td>Salt</td>
              <td>0.07g</td>
              <td>0.03g</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  } else if (handle.indexOf('banana') > -1) {
    return (
      <div>
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>per 100g</th>
              <th>per 45g serving</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Energy</td>
              <td>1361.7kJ</td>
              <td>612.8kJ</td>
            </tr>
            <tr>
              <td>Energy</td>
              <td>324.8kcal</td>
              <td>146.1kcal</td>
            </tr>
            <tr>
              <td>Fat</td>
              <td>19.1g</td>
              <td>8.6g</td>
            </tr>
            <tr>
              <td>&nbsp; &nbsp; &nbsp;of which saturates</td>
              <td>5.0g</td>
              <td>2.2g</td>
            </tr>
            <tr>
              <td>Carbohydrates</td>
              <td>27.8g</td>
              <td>12.5g</td>
            </tr>
            <tr>
              <td>&nbsp; &nbsp; &nbsp;of which sugars</td>
              <td>12.4g</td>
              <td>5.6g</td>
            </tr>
            <tr>
              <td>Added Sugar</td>
              <td>0.0g</td>
              <td>0.0g</td>
            </tr>
            <tr>
              <td>Fibre</td>
              <td>7.4g</td>
              <td>3.3g</td>
            </tr>
            <tr>
              <td>Protein</td>
              <td>9.7g</td>
              <td>4.4g</td>
            </tr>
            <tr>
              <td>Salt</td>
              <td>0.04g</td>
              <td>0.02g</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  } else if (handle.indexOf('cherry') > -1) {
    return (
      <div>
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>per 100g</th>
              <th>per 45g serving</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Energy</td>
              <td>1347.6kJ</td>
              <td>606.4kJ</td>
            </tr>
            <tr>
              <td>Energy</td>
              <td>321.1kcal</td>
              <td>144.5kcal</td>
            </tr>
            <tr>
              <td>Fat</td>
              <td>18.5g</td>
              <td>8.3g</td>
            </tr>
            <tr>
              <td>&nbsp; &nbsp; &nbsp;of which saturates</td>
              <td>6.3g</td>
              <td>2.8g</td>
            </tr>
            <tr>
              <td>Carbohydrates</td>
              <td>29.0g</td>
              <td>13.0g</td>
            </tr>
            <tr>
              <td>&nbsp; &nbsp; &nbsp;of which sugars</td>
              <td>16.7g</td>
              <td>7.5g</td>
            </tr>
            <tr>
              <td>Added Sugar</td>
              <td>0.0g</td>
              <td>0.0g</td>
            </tr>
            <tr>
              <td>Fibre</td>
              <td>5.9g</td>
              <td>2.7g</td>
            </tr>
            <tr>
              <td>Protein</td>
              <td>9.1g</td>
              <td>4.1g</td>
            </tr>
            <tr>
              <td>Salt</td>
              <td>0.06g</td>
              <td>0.03g</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}
